const defaultState = () => {
    return {
        pdfPayload: null,
    }
}

const state = defaultState();

const getters = {
    // Optional: a quick way to check if a download is currently queued
    isGeneratingPdf: (state) => state.pdfPayload !== null
}

const actions = {}

const mutations = {
    START_PDF_DOWNLOAD(state, payload) {
        state.pdfPayload = payload;
    },

    CLEAR_PDF_DOWNLOAD(state) {
        state.pdfPayload = null;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};